// export const wpApiUrl = "https://easytribe.com2go.co/wp-json/easywoo/v1/";
export const wpApiUrl = "http://easytribe.com2go.co/wp-json/easywoo/v1/";
// const nodeApiUrl = 'https://api.easywoo.com2go.co/';

export const nodeApiUrl = "http://199.250.206.103:49152/";

export const imageUrl = "https://easytribe.com2go.co/";
